import {formatTime, msToReadableTime} from "./util";

//Date,Datetime,Time formatter
const formatTimeStampCellValue = (timestamp: any, type: string) => {
  return type === "Time" && Array.isArray(timestamp)
    ? timestamp.map((ts: any) => formatTimestamp(ts, type)).join(" , ")
    : formatTimestamp(timestamp, type);
};
const formatTimestamp = (timestamp: string | number, type: string) => {
  const date = new Date(Number(timestamp));
  return isNaN(date.getTime())
    ? "-"
    : new Intl.DateTimeFormat("en-GB", {
        ...(type === "Date" && {
          day: "2-digit",
          month: "short",
          year: "numeric"
        }),
        ...(type === "Datetime" && {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        }),
        ...(type === "Time" && {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        })
      }).format(date);
};

//SwipeLocations formatter
const formatSwipeLocationValue = (swipeLocation: any[]) => {
  if (!Array.isArray(swipeLocation)) return "";

  return swipeLocation
    .map((item: any) => {
      if (!item?.swipe || !item?.location) return "";
      return formatTime(item.swipe);
    })
    .filter(Boolean)
    .join(", ");
};
//SwipeTimings formatter
const formatSwipeVehicleTimingValue = (swipeLocation: any[]) => {
  if (!Array.isArray(swipeLocation)) return "";

  return swipeLocation
    .map((entry: any) => {
      const times = entry.swipes?.length
        ? entry.swipes.map((t: number) => formatTime(t)).join(", ")
        : "No swipes";

      return `${entry.vehicle} (${times})`;
    })
    .join(" | ");
};

//Duration formatter
const formatDuration = (duration: number) => {
  return duration === 0 ? "0 Min" : `${msToReadableTime(duration)}`;
};

//Location formatter
const formatLocation = (latLngs: any) => {
  return Array.isArray(latLngs)
    ? latLngs.length > 1
      ? // Multiple points Used Google Maps Directions URL LIKE (https://www.google.com/maps/dir/)
        (() => {
          return latLngs.map((latLng: string) => latLng.trim()).join(",");
        })()
      : // Single point Google Maps URL LIKE (https://www.google.com/maps/search/?api=1&query=lat,lng)
        // ["latLLng"] If latLngs is an array with a single value, we can still use the same logic
        latLngs.map((latLng: string, index: number) => {
          latLng = latLng.trim();
          return `${latLng} `;
        })
    : (() => {
        return latLngs.trim();
      })();
};

//Attendance formatter
const formatAttendance = (attendance: string) => {
  const isPresent = attendance?.toLowerCase() === "present";
  return isPresent;
};

//tripType formatter
const formatTripType = (tripType: string) => {
  const isPickup =
    tripType === "Onward" || tripType === "Pickup" || tripType == "0";
  return isPickup;
};

//Yes No Options formatter
const formatYesNoOptions = (value: any) => {
  const booleanValue =
    typeof value === "boolean" ? (value === true ? "Yes" : "No") : value === 1;
  return booleanValue;
};
export const formatCellValue = {
  formatTimeStampCellValue,
  formatTimestamp,
  formatSwipeLocationValue,
  formatSwipeVehicleTimingValue,
  formatDuration,
  formatLocation,
  formatAttendance,
  formatTripType,
  formatYesNoOptions
};
